import {
  // mobileMinWidth,
  tabletMdWidth,
  tabletMinWidth,
  desktopMinWidth,
  mediumDesktopMaxWidth
} from './breakpoints'

export const mobile = `@media (max-width: ${tabletMinWidth - 1}px) `

export const notMobile = `@media (min-width: ${tabletMinWidth}px) `

export const tablet = `@media (min-width: ${tabletMinWidth}px) and (max-width: ${desktopMinWidth -
  1}px)`

export const smTablet = `@media (min-width: ${tabletMinWidth}px) and (max-width: ${tabletMdWidth -
  1}px)`

export const mdDesktop = `@media (min-width: ${desktopMinWidth}px) and (max-width: ${mediumDesktopMaxWidth -
  1}px)`

export const desktop = `@media (min-width: ${desktopMinWidth}px)`

export const customDeviceQuery = (minWidth, maxWidth) =>
  `@media (min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`

export const minDeviceWidth = minWidth => `@media (min-width: ${minWidth}px)`

export const maxDeviceWidth = maxWidth => `@media (max-width: ${maxWidth}px)`
